module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [(_vm.showModal) ? _c('div', {
    staticClass: "modal",
    on: {
      "click": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('button', {
    staticClass: "btn btn--mobile-close",
    on: {
      "click": _vm.onClose
    }
  }, [_c('span', {
    staticClass: "icon-remove"
  })]), _vm._v(" "), _c(_vm.currentModal, {
    tag: "component",
    attrs: {
      "args": _vm.args
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77bcf9a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Modal.vue
// module id = 445
// module chunks = 2